/**
 * Taking the agent offline while the widget window is closing.
 *
 * An XHR started in `beforeunload` dies with the page, so axios cannot be used on that path. `fetch`
 * with `keepalive: true` is the one request the browser promises to finish after the document is
 * gone. `navigator.sendBeacon` would be the other candidate and is rejected here: it cannot set an
 * Authorization header, and this endpoint is authenticated.
 *
 * Deliberately fire-and-forget. There is no page left to report a failure to, and the agent is also
 * taken offline on every non-unload path, so this is the last of several chances rather than the only
 * one.
 *
 * No campaign id: `go-offline` pauses every softphone campaign ringing the agent server-side, so the
 * request is right even if this window's idea of the live campaign was stale.
 */
export function goOfflineWithKeepalive(accountId, accessToken) {
  if (!accountId || !accessToken || typeof fetch === 'undefined') {
    return false
  }

  const url = `${process.env.VUE_APP_BASE_URL}/customerresources/${accountId}/softphone/campaigns/go-offline`

  try {
    fetch(url, {
      method: 'PUT',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    }).catch(() => {
      // Nothing to recover to - the window is going away.
    })

    return true
  } catch (error) {
    return false
  }
}

export default goOfflineWithKeepalive
